import React, { ReactNode } from "react";

import cn from "classnames";

import styles from "./StandalonePopover.module.scss";

interface Props {
  actions?: ReactNode;
  children: ReactNode;
  contentClassName?: string;
  title: ReactNode;
}

// Basically, this is a fake Popover component, which looks like a Popover, but
// doesn't require wrapping anything. It behaves like a modal, but looks like popover.
const StandalonePopover: React.FC<Props> = ({ actions, children, contentClassName, title }) => {
  return (
    <div className={styles.panel}>
      {title ? (
        <div className={styles.header}>
          <div className={styles.title}>{title}</div>
          {actions && <div className={styles.actions}>{actions}</div>}
        </div>
      ) : null}
      <div className={cn(styles.content, contentClassName)}>{children}</div>
    </div>
  );
};

export default StandalonePopover;
